export class Storage {
  hook_url: any;
  buyerCookie: any;
  xmlData: any;
  public cart: any[];

  constructor() {
    this.cart = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/storage/storage.ts